module.exports = __webpack_public_path__ + "img/asset_spot_device.3c47b8c0.png";